export default __webpack_public_path__ + "static/media/footer-logo.966ec5b8.svg";